import React from 'react';
import { CircularProgress, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import MButton from '../../../../MUI/Button/MButton';

export const GeneralIntegrationInfo = ({
  onCheckNowClick,
  lastRunTimestamp,
  problemsDetectedCount,
  isLoading,
}) => {
  return (
    <Stack mb={4}>
      <Stack flexDirection="row" alignItems="center" justifyContent="space-between">
        <Stack gap={2} flexDirection="row" alignItems="center">
          <MButton variant="primary" disabled={isLoading} onClick={onCheckNowClick}>
            {isLoading ? <CircularProgress size={20} /> : 'Check Now'}
          </MButton>
        </Stack>
        <Stack gap={2} flexDirection="row" alignItems="center">
          <MButton variant="secondary" size="small" disabled>
            {problemsDetectedCount ?? 0} problem detected
          </MButton>

          {lastRunTimestamp ? (
            <MButton variant="secondary" size="small" disabled>
              Last checked: {moment(lastRunTimestamp).format('L')}{' '}
              {moment(lastRunTimestamp).format('LT')}
            </MButton>
          ) : null}
        </Stack>
      </Stack>
    </Stack>
  );
};

GeneralIntegrationInfo.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  lastRunTimestamp: PropTypes.string.isRequired,
  problemsDetectedCount: PropTypes.number.isRequired,
  onCheckNowClick: PropTypes.func.isRequired,
};
